import React, { Component } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import 'iframe-resizer/js/iframeResizer.contentWindow'
import './app.css';
import PageTest from '../page/Test';
import NotFound from '../page/404';
import PageAdmin from '../page/Admin';
import PageEditTest from '../page/pageEditTest';
import PageCreateTest from '../page/pageCreateTest';
import PageStatisticTest from '../page/pageStatisticTest';
import PageAnswers from '../page/pageAnswers';

class App extends Component {
  render() {
    return (
      <main role="main" className="main">
        <Router basename={'/quizzes/'}>
          <Switch>
            <Route path="/admin" component={PageAdmin} exact />
            <Route path="/admin/create" component={PageCreateTest} exact />
            <Route path="/admin/edit/:name/:type" component={PageEditTest} exact />
            <Route path="/admin/answers" component={PageAnswers} exact />
            <Route path="/admin/answers/:quiz" component={PageAnswers} exact />
            <Route
              path="/admin/statistic/:name"
              component={PageStatisticTest}
              exact
            />
            <Route path="/:name" component={PageTest} exact />
            <Route path="*" component={NotFound} exact />
          </Switch>
        </Router>
      </main>
    );
  }
}

export default App;
